import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "12",
  fill: "none",
  viewBox: "0 0 10.049 11.999"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m5.025 12-.349-.3C4.196 11.299 0 7.676 0 5.026a5.025 5.025 0 0 1 10.049 0c0 2.65-4.195 6.273-4.674 6.678zm0-10.914a3.943 3.943 0 0 0-3.939 3.938c0 1.666 2.582 4.325 3.939 5.543 1.356-1.218 3.938-3.88 3.938-5.543a3.943 3.943 0 0 0-3.938-3.938"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.025 7.016a1.992 1.992 0 1 1 0-3.983 1.992 1.992 0 0 1 0 3.983m0-2.988a.996.996 0 1 0 0 1.992.996.996 0 0 0 0-1.992"
    }, null, -1)
  ])))
}
export default { render: render }